// @ts-nocheck
/* eslint-disable */

import * as Types from '../../../graphql/v3/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HasMobileAppQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HasMobileAppQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: number, hasMobileApp: boolean } };


export const HasMobileAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasMobileApp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasMobileApp"}}]}}]}}]} as unknown as DocumentNode;
export function useHasMobileAppQuery(baseOptions?: Apollo.QueryHookOptions<HasMobileAppQuery, HasMobileAppQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasMobileAppQuery, HasMobileAppQueryVariables>(HasMobileAppDocument, options);
      }
export function useHasMobileAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasMobileAppQuery, HasMobileAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasMobileAppQuery, HasMobileAppQueryVariables>(HasMobileAppDocument, options);
        }
export function useHasMobileAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasMobileAppQuery, HasMobileAppQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasMobileAppQuery, HasMobileAppQueryVariables>(HasMobileAppDocument, options);
        }
export type HasMobileAppQueryHookResult = ReturnType<typeof useHasMobileAppQuery>;
export type HasMobileAppLazyQueryHookResult = ReturnType<typeof useHasMobileAppLazyQuery>;
export type HasMobileAppSuspenseQueryHookResult = ReturnType<typeof useHasMobileAppSuspenseQuery>;